import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useNavigate, useLocation } from 'react-router-dom';

export default function ProfileTabs({ profileSections }) {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;
  const currentTab = profileSections.find(section => section.path === currentPath)?.value || profileSections[0].value;

  const handleChange = (event, newValue) => {
    const selectedSection = profileSections.find(section => section.value === newValue);
    if (selectedSection) {
      navigate(selectedSection.path);
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={currentTab}
        onChange={handleChange}
        textColor="inherit" 
        indicatorColor="secondary"
        aria-label="profile tabs"
        sx={{
          '.MuiTabs-indicator': {
            backgroundColor: '#117095', 
          },
          '.MuiTab-root': {
            color: '#158cba',
            fontFamily: 'monospace',
            '&.Mui-selected': {
              color: '#158cba',
              fontWeight: 'bold',
            },
            '&:hover': {
              color: '#117095', 
            },
          },
        }}
      >
        {profileSections.map((section, index) => (
          <Tab key={index} value={section.value} label={section.label} />
        ))}
      </Tabs>
    </Box>
  );
}
